/**
 * useSessionRestore
 *
 * Mount-time hook that triggers session restoration.
 * Wire this in the App root (or a top-level layout) to restore
 * the session from persisted wallet + auth stores on page load.
 *
 * Phase 2: Runs alongside existing code. Does NOT drive UI yet.
 */

import { useEffect, useRef } from "react";
import { useSessionManager } from "../session-manager";

export function useSessionRestore(): void {
  const restore = useSessionManager((s) => s.restore);
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;
    restore();
  }, [restore]);
}
